import { useState,useEffect } from 'react';
import { useParams } from "react-router-dom";
import styled from "@emotion/styled";
import MultipleImagesButton from '../../../1elements/Buttons/IconButtons/MultipleImagesButton'
import OneImageButton from '../../../1elements/Buttons/IconButtons/OneImageButton'
import ImageGallery from '../../../2compounds/ImageGallery'
import ApiService from '../../../../common/ApiCalls';
import { reExportedColors } from '../../../1elements'

const ViewMode = ({data}) => {
  const [multiMode,setMultiMode] = useState(false)
  const [photo, setPhoto] = useState([])
  const {tabName,id} = useParams()

  const turnMultipleMode = () => {
    setMultiMode(true)
  }

  const turnSingleMode = () => {
    setMultiMode(false)
  }

  useEffect(()=>{
    const getTabViewData = async () => {
      try {
        const res = await ApiService().getTabView(id, tabName)
        const photoArray =[]
        for(let i = 0; i < res.length; i++){
          if(res[i].card_sys_name === "Card 2"){
            photoArray.push(res[i].data)
          }
        }
        const arrange = photoArray.filter(pic =>pic.length>1)
        setPhoto(arrange)
      } catch (e) {
        console.log(e)
      }
    }
    getTabViewData()

    // XXX Fix this in the future
    // eslint-disable-next-line
  },[])

  return (
    <Container>
      {!multiMode
        ? <ImageGallery images={data.cardData}/>
        :(
          <MultipleList>
            {photo.map((photoData, index)=>(
              <ImageContainer key={index}>
                <ThumbnailDiv>
                  <Pics src={photoData} />
                </ThumbnailDiv>
              </ImageContainer>
            ))}
          </MultipleList>
        )


        ////// HARDCODED TO USE CONSTS - to be Assigned a palette color, BEE_CLEAN_YELLOW doesn't even exist in Colors!!
      }

      <SingleButtonContainer >
        <OneImageButton singleMode={turnSingleMode} border={!multiMode ? `${reExportedColors.BEE_CLEAN_YELLOW} 1px solid` : `${reExportedColors.MEDIUM_GREY} 1px solid`}/>
      </SingleButtonContainer>

      <MultipleButtonContainer>
        <MultipleImagesButton multiMode={turnMultipleMode} border={multiMode ? `${reExportedColors.BEE_CLEAN_YELLOW} 1px solid` : `${reExportedColors.MEDIUM_GREY} 1px solid`}/>
      </MultipleButtonContainer>
    </Container>

  )
}

export default ViewMode

const Container = styled.div({
  height:'100%',
  width:'95%'
})


const SingleButtonContainer = styled.div({
  height:'6%',
  width:'6%',
  position:'absolute',
  top:100,
  right:5,
})



const MultipleButtonContainer = styled.div({
  height:'6%',
  width:'6%',
  position:'absolute',
  top:140,
  right:5,
})



const ThumbnailDiv = styled.div({
  width: "100%",
  height: '100%',
  marginBottom: 5,
  position: 'relative'
})

const ImageContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '65%',
  width:'100%'
})

const Pics = styled.img({
  width: '100%',
  height: 90,
  objectFit: 'cover',
  borderRadius: 3,
})

const MultipleList = styled.div({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px,1fr))",
  gridTemplateRows: "repeat(3, 1fr)",
  gridGap: "10px",
  height: "340px",
  width:"92%",
  alignItems: 'center',
  overflowY: 'auto',
  margin:20
})
